<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xv"><span class="line">ABBREVIATIONS</span></a></p><a id="page_xv">
<table cellpadding="0" cellspacing="0" width="100%">
<tbody><tr><td valign="top"><p class="noindenta">BBC</p></td><td valign="top"><p class="noindenta">British Broadcasting Corporation</p></td></tr>
<tr><td valign="top"><p class="noindenta">Brexit</p></td><td valign="top"><p class="noindenta">Britain exiting from the EU</p></td></tr>
<tr><td valign="top"><p class="noindenta">EEC</p></td><td valign="top"><p class="noindenta">European Economic Community</p></td></tr>
<tr><td valign="top"><p class="noindenta">EU</p></td><td valign="top"><p class="noindenta">European Union</p></td></tr>
<tr><td valign="top"><p class="noindenta">IRA</p></td><td valign="top"><p class="noindenta">Irish Republican Army</p></td></tr>
<tr><td valign="top"><p class="noindenta">MP</p></td><td valign="top"><p class="noindenta">Member of Parliament (of the House of Commons)</p></td></tr>
<tr><td valign="top"><p class="noindenta">NHS</p></td><td valign="top"><p class="noindenta">National Health Service</p></td></tr>
<tr><td valign="top"><p class="noindenta">NUM</p></td><td valign="top"><p class="noindenta">National Union of Mineworkers</p></td></tr>
<tr><td valign="top"><p class="noindenta">ONS</p></td><td valign="top"><p class="noindenta">Office for National Statistics</p></td></tr>
<tr><td valign="top"><p class="noindenta">SNP</p></td><td valign="top"><p class="noindenta">Scottish National Party</p></td></tr>
<tr><td valign="top"><p class="noindenta">UK</p></td><td valign="top"><p class="noindenta">United Kingdom</p></td></tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Abbreviations.vue?43b56259